import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent extends BaseComponent implements OnInit {

  constructor(
  ) {
    super();
  }

  ngOnInit() {
  }

}
